// extracted by mini-css-extract-plugin
export var container = "stepsTitle-module--container--zYodw";
export var desc = "stepsTitle-module--desc--Z0wLO";
export var title = "stepsTitle-module--title--nKui2";